import { OutlinedInput } from "@mui/material";

type Props = {
  errors: any;
  label?: string;
  id: string;
  restProps: any;
  inputProps?: any;
  rows?: number;
  cols?: number;
  show_text?: boolean;
};

function TextArea({
  label,
  errors,
  id,
  restProps,
  inputProps,
  rows = 4,
  cols = 50,
}: Props) {
  return (
    <div className="flex gap-[10px] flex-col">
      <label htmlFor={id} className="text-[16px] ">
        {label}
      </label>
      <div>
        <OutlinedInput
          id={id}
          rows={rows}
          cols={cols}
          multiline
          {...inputProps}
          {...restProps}
          className="bg-white rounded-none w-full"
        />
      </div>
      {errors[id]?.message && errors[id]?.message.length > 0 ? (
        <div className="text-red-600 text-sm cursor-default">
          {errors[id]?.message}
        </div>
      ) : (
        errors[id]?.type === "required" && (
          <div className="text-red-600 text-sm cursor-default">
            {globalThis.translate.em.request.form.fields.required.replace(
              ":id",
              label?.replace("*", "") || id,
            )}
          </div>
        )
      )}
    </div>
  );
}

export default TextArea;
